import { Component, ErrorInfo, ReactNode } from "react";

import AppFallback from "../AppFallback/AppFallback";

type ErrorBoundaryProps = { children: ReactNode };
type ErrorBoundaryState = { hasError: boolean };

/**
 * Catches render-time errors anywhere below it and shows a recoverable fallback
 * instead of a blank white screen — important for unattended kiosk screens.
 */
class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <AppFallback
          title="Something went wrong"
          message="The screen hit an unexpected error. Reloading usually fixes it."
          showReload
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
